import * as React from 'react';

import { SearchSuggestionGroup } from '@wix/thunderbolt-components';
import { TranslationGetter } from '@wix/editor-elements-types';

import * as translations from '../../i18n.constants';
import { OnSuggestionGroupSelectHandler } from '../../../corvid/searchBoxValuePropsSDKFactory';

import style from './Group.scss';

type GroupProps = {
  group: SearchSuggestionGroup;
  id: string;
  onClick: OnSuggestionGroupSelectHandler;
  translate: TranslationGetter;
};

export const Group: React.FC<GroupProps> = ({
  group,
  onClick,
  id,
  translate,
}) => {
  const groupLinkText = translate(
    translations.NAMESPACE,
    translations.SUGGESTION_GROUP_SHOW_ALL_KEY,
    translations.SUGGESTION_GROUP_SHOW_ALL_DEFAULT,
  );

  return (
    <div className={style.root} data-testid={id}>
      <div className={style.inner}>
        <span>{group.title}</span>
        <a
          className={style.showAllLink}
          href={group.url}
          onClick={() => onClick({ syntheticEvent: group })}
          title={`${groupLinkText} ${group.title}`}
        >
          {groupLinkText}
        </a>
      </div>
      <div className={style.divider} />
    </div>
  );
};
